import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export const CustomMenuInternal = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export const CustomMenu = _ref2 => {
  let {
    innerRef,
    innerProps,
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: innerRef
  }, innerProps), children);
};